import { MenuItem } from '@ovComponents/2-component/menuItem/menuItem';
import { TextField } from '@ovComponents/2-component/textField/textField';
import { SeverityFilterPill } from '@ovComponents/4-module/reconFlags/filters/severityFilterPill';
import { Box, Button } from 'hephaestus/web';
import type { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import {
  FLAG_GLOSSARY_SEVERITY_FILTER_PILLS,
  getFlagGlossarySeverityPillInactiveColor,
} from '../utils/flagGlossary.config';
import {
  flagGlossaryFiltersMainRowSx,
  flagGlossaryFiltersSeverityPillsRowSx,
  flagGlossaryFiltersToolbarSx,
  getFlagGlossaryFiltersSearchFieldSx,
} from './flagGlossaryFilters.styles';
import type { FlagGlossaryFiltersCardProps } from './flagGlossaryFiltersCard.types';

export const FlagGlossaryFiltersCard = ({
  theme,
  severityTab,
  onSeverityTabChange,
  categoryFilter,
  onCategoryFilterChange,
  categoryOptions,
  search,
  onSearchChange,
  hasActiveFilters,
  onClearFilters,
}: FlagGlossaryFiltersCardProps) => {
  const { t } = useTranslation(['reconciliation']);

  return (
    <Box sx={flagGlossaryFiltersToolbarSx as any}>
      <Box sx={flagGlossaryFiltersMainRowSx as any}>
        <Box sx={flagGlossaryFiltersSeverityPillsRowSx as any}>
          {FLAG_GLOSSARY_SEVERITY_FILTER_PILLS.map((pill) => (
            <SeverityFilterPill
              key={pill.value}
              label={t(pill.labelKey)}
              active={severityTab === pill.value}
              inactiveBorderAndText={getFlagGlossarySeverityPillInactiveColor(
                theme,
                pill.value,
              )}
              onClick={() => onSeverityTabChange(pill.value)}
              theme={theme}
            />
          ))}
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1 }}>
          {hasActiveFilters && (
            <Button
              variant='text'
              color='primary'
              size='small'
              onClick={onClearFilters}
            >
              {t('flagGlossary.filters.clearFilters')}
            </Button>
          )}
          <TextField
            select
            size='small'
            label={t('flagGlossary.filters.category')}
            value={categoryFilter}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              onCategoryFilterChange(e.target.value)
            }
          >
            <MenuItem value='any'>{t('reconFlags.filters.any')}</MenuItem>
            {categoryOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <Box>
            <TextField
              size='small'
              placeholder={t('flagGlossary.searchPlaceholder')}
              value={search}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                onSearchChange(e.target.value)
              }
              fullWidth
              sx={getFlagGlossaryFiltersSearchFieldSx(theme) as any}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
